import { VisiblityElement } from '@/components/snippets/visibility/visibility'

/**
 * IN VIEW CUSTOM ELEMENT
 * Handled as a custom element due to their being next to no state to manage, and due to how neatly it interacts with Tailwind
 *
 * For set up:
 *   1. Ensure you wrap your elements with <x-in-view>.
 *   2. Pass a 'data-target-id' to specify what component you're keeping track of.
 *   3. Use "gropu-data-visible:" for stateful styling.
 *
 */

class InViewElement extends VisiblityElement {
  constructor() {
    super()

    this.handleObserve = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.handleShow()
        } else {
          this.handleHide()
        }
      })
    }
  }

  connectedCallback() {
    super.connectedCallback()

    const targetElement = this.querySelector(`#${this.dataset.target}`)
    this.observer = new IntersectionObserver(this.handleObserve)
    this.observer.observe(targetElement)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.observer.disconnect()
  }
}

customElements.define('x-in-view', InViewElement)
